import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Grid, Box,useTheme } from '@mui/material';
import {tokens} from '../../../../theme'


const LoadingScreen = () => {
  const theme=useTheme();
  const color=tokens(theme.palette.mode);


  return (
    <Box sx={{width:'100%',display:'flex',justifyContent:'center',p:4}} >
      <CircularProgress  color={'success'} size={45} />
    </Box>
  );
};
export default LoadingScreen;